import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function latinCharsetRegexValidator(): ValidatorFn {

  // latin names with space support for compound names
  const romanisedCharacters = new RegExp(/^[A-Za-z0-9_&.+;:?()<> -]+$/);

  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    if (value && !romanisedCharacters.test(value)) {
      return { invalidCharacters: true };
    }
    return null;
  };
}
